import range from 'lodash-es/range'
import * as React from 'react'

import { IEnhancedLocation } from '../../../../common/reducers/reactRouterLocation'
import { IDecoratedItem } from '../../../../typings/searchResults'
import FeatureContainer from '../../../containers/feature'
import ItemCard from '../../itemCard'
import GraphicRiverEmptyItemCard from '../../itemCard/graphicRiverItemCard/emptyItemCard'
import { IItemsListing } from '../index'

import * as styles from './default.module.css'

interface IProps extends IDecoratedItem {
  location: IEnhancedLocation
}

const Default = ({ items, itemDecorator, viewType }: IItemsListing) => {
  return (
    <ul className={styles.root}>
      {items.map((item, index) => {
        const itemProps = itemDecorator(item, index) as IProps
        return <ItemCard {...itemProps} key={item.id} viewType={viewType} />
      })}
      {range(3).map(item => (
        <React.Fragment key={`empty${item}`}>
          <FeatureContainer name="!narrowItemCard">
            <li
              key={`empty${item}`}
              role="presentation"
              aria-hidden="true"
              className={styles.emptyItem}
            />
          </FeatureContainer>
          <FeatureContainer name="narrowItemCard">
            <GraphicRiverEmptyItemCard />
          </FeatureContainer>
        </React.Fragment>
      ))}
    </ul>
  )
}
export default Default
